import { ref } from 'vue';
import { useAdvertisement } from '@base/hooks';

export const useAuthAdvertisement = (name) => {
  const adImage = ref();

  const advertisementName = name;

  const {
    isAdvertisementLoading,
    advertisement,
    hasSomeAdvertisement,
    handleAvertisementClick,
    fetchAdvertisement,
  } = useAdvertisement(advertisementName, adImage);

  return {
    isAdvertisementLoading,
    advertisement,
    adImage,
    hasSomeAdvertisement,
    handleAvertisementClick,
    fetchAdvertisement,
  };
};
